import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 mt-8 sm:mt-12 lg:mt-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <div className="text-center text-gray-600 dark:text-gray-400">
          <p className="text-sm sm:text-base">{t('footer.copyright')}</p>
          <p className="mt-2 text-xs sm:text-sm max-w-2xl mx-auto leading-relaxed">
            {t('footer.description')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
